import { PureComponent } from 'react'
import ReactLoading from 'react-loading'
import SocialLogin from 'react-social-login'
import facebookRound from '../../assets/icons/facebook_round.svg'
import googleRound from '../../assets/icons/google_round.svg'
import { Container } from './styles'

type SocialButtonProps = {
  type?: 'facebook' | 'google';
  isLoading?: boolean;
  disabled?: boolean;
  triggerLogin: () => void;
}

export type SocialLoginSuccess = {
  _token: {
    idToken?: string
    accessToken: string
    expiresAt: number
  }
}

const icons = {
  facebook: facebookRound,
  google: googleRound
}

class SocialButton extends PureComponent<SocialButtonProps> {
  render () {
    const { triggerLogin, type, isLoading, disabled } = this.props

    return (
      <Container
        type='button'
        onClick={(!isLoading || !disabled) ? triggerLogin : undefined}
        variant={type}
      >
        <div className='icon'>
          {type && <img alt={type} src={icons[type]} />}
        </div>
        <div className='content'>
          {type === 'facebook' && 'Entrar com Facebook'}
          {type === 'google' && 'Entrar com Google'}
          {isLoading && (
            <ReactLoading
              className='spinner'
              type='spin'
              color='#000'
              height={17}
              width={17}
            />
          )}
        </div>
      </Container>
    )
  }
}

export default SocialLogin(SocialButton)
